module.exports = __webpack_public_path__ + "static/media/Feralpi.15309013.png";